"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethods = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PaymentMethods = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    paymentMethodsItems
  } = (0, _hooks.useFooter)();
  if (!paymentMethodsItems || paymentMethodsItems.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.PAYMENT_METHODS),
    children: paymentMethodsItems.map((pm, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      title: pm.title ?? '',
      placement: "top",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Item, {
        "data-testid": getTestId(_constants.PAYMENT_METHOD),
        src: (0, _utils.updateImageUrl)({
          url: pm.imageUrl,
          passPNG: true,
          jpgSettings: _constants.jpgSettings
        }),
        alt: pm.title ?? ''
      })
    }, pm.imageUrl ?? index))
  });
};
exports.PaymentMethods = PaymentMethods;